export const AccountsESocialRelation = [
    {
        id: "S-5001",
        description: "Informações das contribuições sociais por trabalhador;"
    },
    {
        id: "S-5002",
        description: "Imposto de Renda Retido na Fonte;"
    },
    {
        id: "S-5003",
        description: "Informações do FGTS por Trabalhador;"
    },
    {
        id: "S-5011",
        description:
            "Informações das contribuições sociais consolidadas por contribuinte;"
    },
    {
        id: "S-2200",
        description:
            "Cadastramento Inicial do Vínculo e Admissão/Ingresso de Trabalhador;"
    },
    {
        id: "S-2206",
        description: "Alteração de Contrato de Trabalho;"
    },
    {
        id: "S-2299",
        description: "Desligamento;"
    },
    {
        id: "S-1210",
        description: "Pagamentos de Rendimentos do Trabalho."
    }
];
